import React from "react";
import PropTypes from "prop-types";
import CurrencyField from "../components/widgets/CurrencyField";

const NumberCurrencyHoc = (Component, options = { dollarOnly: false }) => {
  const CurrencyFieldWrapper = ({ value, onChange, onNumberChange, ...remaining }) => {
    return (
      <CurrencyField
        value={value}
        onChange={onChange}
        onNumberChange={onNumberChange}
        decimal={options.dollarOnly ? 0 : 2}
        {...remaining}
      />
    );
  };

  CurrencyFieldWrapper.propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func,
    onNumberChange: PropTypes.func,
  };

  return CurrencyFieldWrapper;
};

export default NumberCurrencyHoc;
